<template>
    <div class="one-box">
        <div class="one-title">城市铺设规模</div>
        <div class="one-part-box">
            
                <div ref="citySale" style="width: 100%; height: 104%"></div>
            
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timerId: null,
            startValue: 0,
            endValue: 6,
            // 省份排行 --象形柱状图
            citySaleBase: {},
        };
    },
    mounted() {
        this.__initEcharts();
        this.updateChart();
        this.startInterval()
    },
    destroyed() {
        clearInterval(this.timerId)
    },
    computed: {
        citySaleData: function () {
            return this.$store.getters.getState("citySaleData");
        },
    },
    watch: {
        citySaleData: function (newVal, oldVal) {
            if (this.chart) {
                this.chart.setOption({
                    yAxis: [{ data: newVal.xData }],
                    legend: {
                        data: newVal.seriesData.forEach((item) => item.name),
                    },
                    series: newVal.seriesData,
                });
            }
        },
    },
    methods: {
        // 创建echarts
        __initEcharts() {
            this.chart = this.$echarts.init(this.$refs.citySale);
            const initOptions = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        shadowStyle: {
                            color: "rgba(14,252,255,0.25)",
                        },
                    },
          
                },
                legend: {
                    top: "2%",
                    right: "5%",
                    textStyle: {
                        color: "#fff",
                        fontSize: this.$util.fontSizeFun(0.11),
                    },
                },
                grid: {
                    left: '30%',
                },
                xAxis: {
                    type: 'log',
                    splitLine: { show: false },
                    // 轴坐标颜色
                    axisLine: {
                        lineStyle: {
                            color: "#6076AD",
                            padding: 1,
                            type: "solid",
                        },
                    },
                    //刻度上字体样式
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#ffffff",
                            fontSize: this.$util.fontSizeFun(0.1),
                        },
                        margin: 2,
                        formatter: function (value, index) {
                            if (value >= 10000 && value < 10000000) {
                                value = value / 10000 + "万";
                            } else if (value >= 10000000) {
                                value = value / 10000000 + "千万";
                            }
                            return value;
                        },
                        interval: 0,
                    },
                    //刻度样式
                    axisTick: {
                        alignWithLabel: true,
                        length: 1,
                        color: "#ffffff",
                        lineStyle: {
                            color: "#ffffff",
                        },
                    },
                },
                yAxis: {
                    inverse: true, //是否是反向坐标轴
                    data: [],
                    // 轴坐标颜色
                    axisLine: {
                        lineStyle: {
                            color: "#6076AD",
                            padding: 1,
                            type: "solid",
                        },
                    },
                    //刻度上字体样式
                    axisLabel: {
                        show: true,
                        width: 500,
                
                        textStyle: {
                            color: "#ffffff",
                            fontSize: 17,
                            width: 500,
                        },
        
                        formatter: function (value) {
                            if (value.length > 8) {
                                return value.replace(/(.{8})/g, "$1\n")     
                                // return value.substring(0, 8) + "...";
                                // return '<div style="white-space: nowrap; overflow: hidden; text-overflow: marquee;">' + value + '</div>';
                            }
                            return value;
                        },
                        interval: 0,
                        
                    },
                    //刻度样式
                    axisTick: {
                        alignWithLabel: true,
                        length: 1,
                        color: "#ffffff",
                        lineStyle: {
                            color: "#ffffff",
                        },
                    },
                },
                series: [
                    // 可铺设房间数柱状
                    {
                        type: "bar",
                        barWidth: "30",
                        color:"#00c7f9",
                        emphasis: {
                            itemStyle: {
                                color: "#FFFF00",
                            },
                        },
                        itemStyle: {
                            barBorderRadius: [0, 8, 8, 0],
                        },
                        label: {
                            show: true, //开启显示
                            position: "inside", //在上方显示
                            textStyle: {
                                //数值样式
                                color: "#fff",
                                fontSize: this.$util.fontSizeFun(0.12),
                            },
                            formatter: function (ags) {
                                if (ags.value >= 10000 && ags.value < 10000000) {
                                    return (ags.value / 10000).toFixed(1) + "万";
                                }
                                if (ags.value >= 10000000) {
                                    return (ags.value / 10000000).toFixed(1) + "千万";
                                }
                            }
                        },
                    },
                    // 已铺设房间数柱状
                    // {
                    //     type: "bar",
                    //     barWidth: "12",
                    //     label: {
                    //         show: true, //开启显示
                    //         position: "right", //在上方显示
                    //         textStyle: {
                    //             //数值样式
                    //             color: "#fff",
                    //             fontSize: this.$util.fontSizeFun(0.12),
                    //         },
                    //         formatter: function (ags) {
                    //             if (ags.value >= 10000 && ags.value < 10000000) {
                    //                 return (ags.value / 10000).toFixed(1) + "万";
                    //             }
                    //             if (ags.value >= 10000000) {
                    //                 return (ags.value / 10000000).toFixed(1) + "千万";
                    //             }
                    //         }
                    //     },
                    //     // 柱状图样式
                    //     color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    //         { offset: 0, color: "#fff59c" },
                    //     ]),
                    //     // hover效果
                    //     emphasis: {
                    //         itemStyle: {
                    //             color: "#FFFF00",
                    //         },
                    //     },
                    //     itemStyle: {
                    //         barBorderRadius: [0, 8, 8, 0],
                    //     },
                    // },
                ],
            }
            this.chart.setOption(initOptions);
            // setTimeout(() => {
            //     this.$tools.autoHover(this.chart, initOptions, 0, 33, 2500, "A11");
            // }, 2000);
            this.chart.on('mouseover', () => {
                clearInterval(this.timerId)
            })
            this.chart.on('mouseout', () => {
                this.startInterval()
            })
        },

        updateChart() {
            const updateOptions = {
                dataZoom: {
                    show: false,
                    type: 'slider',
                    yAxisIndex: 0,
                    startValue: this.startValue,
                    endValue: this.endValue
                },
            }
            this.chart.setOption(updateOptions);
        },

        startInterval() {
            if (this.timerId) {
                clearInterval(this.timerId)
            }
            this.timerId = setInterval(() => {
                this.startValue++
                this.endValue++
                if (this.endValue == this.citySaleData.xData.length) {
                    this.startValue = 0
                    this.endValue = 6
                }
                this.updateChart()
            }, 2000)
        }
    },
};
</script>

<style scoped>
.one-box {
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/moudles/CitySaleMoudle.vue